import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_3 = { class: "control-label col-sm-6" }
const _hoisted_4 = { class: "col-sm" }
const _hoisted_5 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_6 = { class: "control-label col-sm-6" }
const _hoisted_7 = { class: "col-sm" }
const _hoisted_8 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_9 = { class: "control-label col-sm-6" }
const _hoisted_10 = { class: "col-sm" }
const _hoisted_11 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_12 = { class: "control-label col-sm-6" }
const _hoisted_13 = { class: "col-sm" }
const _hoisted_14 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_15 = { class: "control-label col-sm-6" }
const _hoisted_16 = { class: "col-sm" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_19 = { class: "control-label col-sm-6" }
const _hoisted_20 = { class: "col-sm" }
const _hoisted_21 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_22 = { class: "control-label col-sm-6" }
const _hoisted_23 = { class: "col-sm" }
const _hoisted_24 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_25 = { class: "control-label col-sm-6" }
const _hoisted_26 = { class: "col-sm" }
const _hoisted_27 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_28 = { class: "control-label col-sm-6" }
const _hoisted_29 = { class: "col-sm" }
const _hoisted_30 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_31 = { class: "control-label col-sm-6" }
const _hoisted_32 = { class: "col-sm" }
const _hoisted_33 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_34 = { class: "control-label col-sm-6" }
const _hoisted_35 = { class: "col-sm" }
const _hoisted_36 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_37 = { class: "control-label col-sm-6" }
const _hoisted_38 = { class: "col-sm" }

import { ref, watch , inject } from 'vue';
import { usePreventivo } from '../../composable/usePreventivo';
import FormImmobiliareHelper from "./../../pages/preventivi/json/immobiliare/helper.json";
import DettaglioPreventivoHelper from "../../pages/preventivi/json/dettagliopreventivo/helper.json";
import CalcoloEquoCompenso from "./CalcoloEquoCompenso.vue";
import RegimeFiscale from "./RegimeFiscale.vue";
import AliquoteContributiRepertoriali from "./AliquoteContributiRepertoriali.vue";

export default {
  __name: 'FormImmobiliareDivisioni',
  props: {
  formName: String,
  tipoPreventivo: Object,
  disabilita: Boolean,
  readonly: Boolean
},
  emits: ['changeDatiPreventivo','infoCompilazione'],
  setup(__props, { emit: __emit }) {

const props = __props;
const {
  categoriaImmobiliare
} = usePreventivo();
let validazione;
const validazioneEquoCompenso = ref();
const { regimeFiscale } = inject('regimeFiscale')
switch (props.formName) {
  case 'divisioniSenzaConguagli':
    validazione = categoriaImmobiliare['sottocategoriaDivisioni']['divisioniSenzaConguagli'];
    validazioneEquoCompenso.value = categoriaImmobiliare['sottocategoriaDivisioni']['divisioniSenzaConguagli'];
    break
  case 'divisioniConConguagli':
    validazione = categoriaImmobiliare['sottocategoriaDivisioni']['divisioniConConguagli'];
    validazioneEquoCompenso.value = categoriaImmobiliare['sottocategoriaDivisioni']['divisioniConConguagli'];
    break
}
// Aggiungiamo il valore a tipo_parametro che sar� un path alla pagina (mantenendo il nome)
if(validazione){
  validazione.tipo_preventivo.value = 'immobiliare/divisioni/' + props.tipoPreventivo.data.url
}
const emits = __emit;
const testoInfoCompilazione = ref([]);
testoInfoCompilazione.value =  FormImmobiliareHelper.sottocategoriaDivisioni[props.formName];
emits('infoCompilazione',  testoInfoCompilazione);
let indexHelperClosing ={
  calcolo: FormImmobiliareHelper.sottocategoriaDivisioni[props.formName],
  dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
}
watch(validazione, (newValue, oldValue) => {
  emits('changeDatiPreventivo');
}, { deep: true })
function controlloNumeroConservatorie(event){
 let numero = event.target.value;
 if(numero > 1){
   validazione.imposta_ipotecaria_per_ciascuna_conservatoria.required = true;
 } else {
   validazione.imposta_ipotecaria_per_ciascuna_conservatoria.required = false;
 }
}

return (_ctx, _cache) => {
  const _component_the_helper = _resolveComponent("the-helper")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _component_base_select = _resolveComponent("base-select")
  const _component_base_input_checkbox = _resolveComponent("base-input-checkbox")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_helper, {
      list: _unref(indexHelperClosing),
      "is-closing": true
    }, null, 8 /* PROPS */, ["list"]),
    (__props.formName === 'divisioniSenzaConguagli')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(validazione).valore_massa.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_massa.ref]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_input_text, {
                id: "valore_massa",
                name: "valore_massa",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).valore_massa,
                "onUpdate:validateTo": _cache[0] || (_cache[0] = $event => ((_unref(validazione).valore_massa) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_6, [
              _createTextVNode(_toDisplayString(_unref(validazione).numero_conservatorie.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_conservatorie.ref]
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_base_input_text, {
                id: "numero_conservatorie",
                name: "numero_conservatorie",
                class: "placeholder-right crm:text-right",
                placeholder: "Indicare numero conservatorie",
                disabled: __props.readonly,
                onChange: _cache[1] || (_cache[1] = $event => (controlloNumeroConservatorie($event))),
                "validate-to": _unref(validazione).numero_conservatorie,
                "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((_unref(validazione).numero_conservatorie) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          (_unref(validazione).numero_conservatorie.value > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.imposta_ipotecaria_per_ciascuna_conservatoria.ref]
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_base_select, {
                    name: "imposta_ipotecaria_per_ciascuna_conservatoria",
                    options: [{name: 'Si', value: 'si'},{name: 'No', value: 'no'}],
                    isSelected: _unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria.value != '',
                    state: __props.readonly == true ?'disable':'',
                    validateTo: _unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria,
                    "onUpdate:validateTo": _cache[3] || (_cache[3] = $event => ((_unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_12, [
              _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_base_select, {
                name: "forma_del_titolo",
                options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                isSelected: _unref(validazione).forma_del_titolo.value != '',
                state: __props.readonly == true ?'disable':'',
                validateTo: _unref(validazione).forma_del_titolo,
                "onUpdate:validateTo": _cache[4] || (_cache[4] = $event => ((_unref(validazione).forma_del_titolo) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
            ])
          ]),
          (_unref(regimeFiscale) == 'ordinario')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_15, [
                  _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_base_input_checkbox, {
                    class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                    name: "ritenuta_acconto",
                    label: "Si, applicabile",
                    "validate-to": _unref(validazione).ritenuta_acconto,
                    "onUpdate:validateTo": _cache[5] || (_cache[5] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                  }, null, 8 /* PROPS */, ["class", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(AliquoteContributiRepertoriali, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(CalcoloEquoCompenso, {
            "input-riferimento-calcolo": "valore_massa",
            validazione: validazioneEquoCompenso.value,
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
        ]))
      : (__props.formName === 'divisioniConConguagli')
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_19, [
                _createTextVNode(_toDisplayString(_unref(validazione).valore_massa.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_massa.ref]
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_base_input_text, {
                  id: "valore_massa",
                  name: "valore_massa",
                  class: "placeholder-right",
                  placeholder: "0,00",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).valore_massa,
                  "onUpdate:validateTo": _cache[6] || (_cache[6] = $event => ((_unref(validazione).valore_massa) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_22, [
                _createTextVNode(_toDisplayString(_unref(validazione).valore_conguaglio.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_conguaglio.ref]
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_base_input_text, {
                  id: "valore_conguaglio",
                  name: "valore_conguaglio",
                  class: "placeholder-right",
                  placeholder: "0,00",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).valore_conguaglio,
                  "onUpdate:validateTo": _cache[7] || (_cache[7] = $event => ((_unref(validazione).valore_conguaglio) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_25, [
                _createTextVNode(_toDisplayString(_unref(validazione).numero_conservatorie.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_conservatorie.ref]
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_base_input_text, {
                  id: "numero_conservatorie",
                  name: "numero_conservatorie",
                  class: "placeholder-right",
                  placeholder: "Indicare numero conservatorie",
                  onChange: _cache[8] || (_cache[8] = $event => (controlloNumeroConservatorie($event))),
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).numero_conservatorie,
                  "onUpdate:validateTo": _cache[9] || (_cache[9] = $event => ((_unref(validazione).numero_conservatorie) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            (_unref(validazione).numero_conservatorie.value > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_28, [
                    _createTextVNode(_toDisplayString(_unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.imposta_ipotecaria_per_ciascuna_conservatoria.ref]
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_base_select, {
                      name: "imposta_ipotecaria_per_ciascuna_conservatoria",
                      options: [{name: 'Si', value: 'si'},{name: 'No', value: 'no'}],
                      isSelected: _unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria.value != '',
                      state: __props.readonly == true ?'disable':'',
                      validateTo: _unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria,
                      "onUpdate:validateTo": _cache[10] || (_cache[10] = $event => ((_unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria) = $event))
                    }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_30, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_31, [
                _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_base_select, {
                  name: "forma_del_titolo",
                  options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                  isSelected: _unref(validazione).forma_del_titolo.value != '',
                  state: __props.readonly == true ?'disable':'',
                  validateTo: _unref(validazione).forma_del_titolo,
                  "onUpdate:validateTo": _cache[11] || (_cache[11] = $event => ((_unref(validazione).forma_del_titolo) = $event))
                }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_34, [
                _createTextVNode(_toDisplayString(_unref(validazione).tipologia.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipologia.ref]
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_base_select, {
                  name: "tipologia",
                  options: [{name: 'Prima casa', value: 'prima_casa'},{name: 'Terreno agricolo', value: 'terreno_agricolo'},{name: 'Altra tipologia', value: 'altra_tipologia'}],
                  isSelected: _unref(validazione).forma_del_titolo.value != '',
                  state: __props.readonly == true ?'disable':'',
                  validateTo: _unref(validazione).tipologia,
                  "onUpdate:validateTo": _cache[12] || (_cache[12] = $event => ((_unref(validazione).tipologia) = $event))
                }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
              ])
            ]),
            (_unref(regimeFiscale) == 'ordinario')
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_37, [
                    _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_base_input_checkbox, {
                      class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                      name: "ritenuta_acconto",
                      label: "Si, applicabile",
                      "validate-to": _unref(validazione).ritenuta_acconto,
                      "onUpdate:validateTo": _cache[13] || (_cache[13] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                    }, null, 8 /* PROPS */, ["class", "validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(RegimeFiscale, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(AliquoteContributiRepertoriali, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(CalcoloEquoCompenso, {
              "input-riferimento-calcolo": "valore_massa",
              validazione: validazioneEquoCompenso.value,
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
          ]))
        : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}